import { ValidationRule } from '../validation.rule';
import { ValidationTypes } from '../validationtypes';

export class LengthValidationRule extends ValidationRule {
  private length: number;

  constructor(length: number, key: string | null) {
    if (!key) {
      key = ValidationTypes.exactLength;
    }

    super(key);

    this.length = length;
  }

  isValid(value: any): boolean {
    if (!value) {
      return true;
    }

    return value.length == this.length;
  }
}
